import {
  GET_PATIENT_STATS,
  GET_EMAIL_MILESTONE,
  GET_FORM_MILESTONE,
  GET_LOGIN_MILESTONE,
  LOADER,
  GET_APPOINTMENT_PROCESS_TRACKER
} from './constants';

const initialState = {
  patientStats: [],
  emailMileStone: [],
  loginMileStone: [],
  formMileStone: [],
  loading: false,
  processTrackerData: null
};

const PatientInteractionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER:
      return { ...state, loading: true };
    case GET_PATIENT_STATS:
      return { ...state, patientStats: action.payload.data, loading: false };
    case GET_EMAIL_MILESTONE:
      return { ...state, emailMileStone: action.payload.data, loading: false };
    case GET_LOGIN_MILESTONE:
      return { ...state, loginMileStone: action.payload.data, loading: false };
    case GET_FORM_MILESTONE:
      return { ...state, formMileStone: action.payload.data, loading: false };
    case GET_APPOINTMENT_PROCESS_TRACKER:
      return {
        ...state,
        processTrackerData: action.payload.data,
        loading: false
      };
    default:
      return state;
  }
};

export default PatientInteractionReducer;
